export interface Input extends Marko.HTML.Input {}

<const/{ class: className, style, ...attrs }=input>
<input
  style=["border-color:var(--gray-300)", style]
  class=["border-solid border1 pi-2 pb-1 radius1 text-fore bg-back", className]
  ...attrs
>
